export enum TaxStatusThreshold {
  NoInvestment = 999,
  LowLim = 0.0,
  MediumLeftLim = 0.0001,
  MediumRightLim = 15,
  BiggerLeftLim = 15.0001,
  BiggerRightLim = 100,
}
